module.exports = __webpack_public_path__ + "img/header.f74b7972.svg";